import { Input, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const UnitSpan = styled.span`
  font-size: 18px;
  color: #686868;
  align-self: end;
  margin-bottom: 6px;
`;

export const LabelText = styled.div`
  color: #9b9b9b;
  margin-right: 10px;
  font-size: 13px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
`;

export const ThresholdInputWrapper = styled.div<{ $error: boolean }>`
  height: 60%;
  background-color: #f6f6f6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 5px 20px;
  width: 200px;
  outline: ${({ $error }) => ($error ? '2px' : '0px')} solid #d0021b;
`;

export const StyledInput = styled(Input)`
  text-align: right;
  font-size: 30px;
  font-weight: 600;
  color: #686868;
  padding: 0 10px;
`;

export const ResetToConviva = styled(ReloadOutlined)<{ $disabled: boolean }>`
  font-size: 23px;
  color: ${({ $disabled }) => ($disabled ? 'inherit' : '#0146ff')};
`;

export const ResetBtn = styled(Button)`
  flex: 0 0 35px;
  height: 35px;
`;
